import { createAction } from 'redux-act';
// common
import { getReportActions } from '../../report-common';
//////////////////////////////////////////////////

const setValueToStore = createAction('setValueToStore');
const getDashboardGroups = createAction('getDashboardGroups');
const getDashboardSuccess = createAction('getDashboardSuccess');
const setDateFiltersToStore = createAction('setDateFiltersToStore');
const setDashboardTypeToStore = createAction('setDashboardTypeToStore');
const getChartByFiltersRequest = createAction('getChartByFiltersRequest');
const getIndividualChartSuccess = createAction('getIndividualChartSuccess');
const setEnterpriseFilterToStore = createAction('setEnterpriseFilterToStore');
const getNormalizedCurrencyRequest = createAction('getNormalizedCurrencyRequest');
const getNormalizedCurrencySuccess = createAction('getNormalizedCurrencySuccess');
const setIndividualChartLoadingState = createAction('setIndividualChartLoadingState');

const { setTableTitleSort, setTableTitleFilter } = getReportActions();

const generateExcelWithChartData = createAction('generateExcelWithChartData');

export {
  setValueToStore,
  setTableTitleSort,
  getDashboardGroups,
  getDashboardSuccess,
  setTableTitleFilter,
  setDateFiltersToStore,
  setDashboardTypeToStore,
  getChartByFiltersRequest,
  getIndividualChartSuccess,
  generateExcelWithChartData,
  setEnterpriseFilterToStore,
  getNormalizedCurrencyRequest,
  getNormalizedCurrencySuccess,
  setIndividualChartLoadingState,
};

